import { useRouteError } from "react-router";
import { AuthLayout } from "../pages/auth/AuthLayout";
import { Button } from "../shared/ds";

/** Shown when a screen fails to load (e.g. a chunk from an old deploy) or throws while rendering. */
export function RouteError() {
  const error = useRouteError();
  const chunk = error instanceof Error && /dynamically imported module|Failed to fetch|Importing a module script failed/i.test(error.message);
  console.error("route error", error);
  return (
    <AuthLayout
      title={chunk ? "Há uma versão nova da sautria" : "Algo deu errado nesta tela"}
      subtitle={chunk ? "Recarregue para continuar com a versão mais recente." : "Seus dados estão salvos. Recarregue a página para tentar de novo."}
    >
      <Button type="button" className="auth-block" onClick={() => window.location.reload()}>
        Recarregar
      </Button>
    </AuthLayout>
  );
}
